import type { FaireProductEntity } from "../../entity_types/product";

export const p_a953k23cu7: FaireProductEntity = {
  token: "p_a953k23cu7",
  type: "product",
  name: "Vintage Floral Baby Moccasins",
  brandToken: "b_9njqbd73",
  brandName: "Trendy Baby Mocc Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/50073f357c00bfc3e090f4457318b2694ca6054ff26c18a067d6752512ebb90a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05cbc9347f48d1be923441be0100ef68642ca340dc23e05ddf6b4175572165a6.jpeg",
    "https://cdn.faire.com/fastly/4f9788aa141aafe4c304fac029285a6299d65297acb5af66f3014128a9bd2c41.jpeg",
  ],
  priceDollars: 13.49,
  description:
    'Looking for trendy, comfortable moccasins guaranteed to stay on your baby or toddler\'s feet? These one-of-a-kind, handmade moccasins are head-turners that can be paired with any outfit your baby or tot has on. Each handmade moccasin pair is made with durable cloth and layers of felt and lined with luscious fleece for extra comfort to keep your baby\'s feet soft and breathable. \n\nSizing is as follows: \n0-3 mos: 3.25"\n3-6 mos: 4.5"\n6-9 mos: 4.75"\n9-12 mos: 5.25"\n12-18 mos: 5.5"\n18-24 mos: 6"\n2-2.5 years: 6.5"',
  tags: [],
  msrpDollars: 26.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:59.082Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
